import { Permission } from "~/graphql/client"

import type { IPart, IStep, StepId } from "./setup-steps-types"
import ContractStatus from "./Steps/ContractStatus/ContractStatus"
import { EnergyConsumption } from "./Steps/EnergyConsumption/EnergyConsumption"
import { FinancingSelection } from "./Steps/FinancingSelection/FinancingSelection"
import IncentivesSelection from "./Steps/IncentivesSelection"
import InverterSelection from "./Steps/InverterSelection"
import { ModuleSelectionSetupForm } from "./Steps/ModuleSelection_new"
import MountSelection from "./Steps/MountSelection"
import { AddersOverview } from "./Steps/Pricing/Overview"
import AddersSelection from "./Steps/Pricing/Pricing"
import { SharePresentation } from "./Steps/SharePresentation"
import StorageSelection from "./Steps/StorageSelection"
import SystemDesign from "./Steps/SystemDesign"
import VppIncentivesSelection from "./Steps/VppIncentivesSelection"

export const setupStepsIndex: Record<StepId, IStep> = {
  [`home-and-utility-info`]: {
    id: `home-and-utility-info`,
    title: `homeAndUtilityInfo`,
    parts: [
      {
        id: `homeowner-information`,
        title: `siteInformation`,
        summary: `siteInformationDesc`,
        required_permissions: [
          Permission.admin,
          Permission.vision_user_admin,
          Permission.vision_admin,
          Permission.vision_proposal_admin,
        ],
      },
      {
        id: `utility-company-and-rate`,
        title: `utilityCompanyAndRate`,
        summary: `utilityCompanyAndRateDesc`,
      },
      {
        id: `energy-consumption`,
        title: `energyConsumption`,
        summary: `energyConsumptionDesc`,
        form: EnergyConsumption as IPart[`form`],
      },
      {
        id: `greenbutton-data`,
        title: `greenbuttonData`,
      },
    ],
  },
  [`product-offering`]: {
    id: `product-offering`,
    title: `productOffering`,
    parts: [
      {
        id: `funding-selection`,
        title: `fundingPartnerAndEquipment`,
        summary: `fundingSelectionDesc`,
      },
      {
        id: `financial-product-selection`,
        title: `financialProduct`,
        form: FinancingSelection,
      },
    ],
  },
  [`equipment-selection`]: {
    id: `equipment-selection`,
    title: `equipmentSelection`,
    parts: [
      {
        id: `module-selection`,
        title: `moduleSelection`,
        summary: `moduleSelectionDesc`,
        form: ModuleSelectionSetupForm,
      },
      {
        id: `inverter-selection`,
        title: `inverterSelection`,
        summary: `inverterSelectionDesc`,
        form: InverterSelection,
      },
      {
        id: `storage-selection`,
        title: `storageSelection`,
        summary: `storageSelectionDesc`,
        form: StorageSelection,
      },
      {
        id: `mount-selection`,
        title: `mountSelection`,
        summary: `mountSelectionDesc`,
        form: MountSelection,
      },
    ],
  },
  [`system-placement`]: {
    id: `system-placement`,
    title: `systemPlacement`,
    parts: [
      {
        id: `system-placement-tool`,
        title: `systemDesign`,
        summary: `systemDesignDesc`,
        form: SystemDesign,
      },
      {
        id: `aurora-design`,
        title: `auroraDesign`,
      },
    ],
  },
  [`pricing`]: {
    id: `pricing`,
    title: `pricing`,
    parts: [
      {
        id: `select-adders`,
        title: `selectAdders`,
        summary: `selectAddersDesc`,
        form: AddersSelection,
      },
      {
        id: `system-pricing-overview`,
        title: `systemPricingOverview`,
        summary: `systemPricingOverviewDesc`,
        form: AddersOverview,
      },
    ],
  },
  [`incentives`]: {
    id: `incentives`,
    title: `incentives`,
    parts: [
      {
        id: `select-incentives`,
        title: `selectIncentives`,
        form: IncentivesSelection,
      },

      {
        id: `vpp-incentives`,
        title: `vppIncentives`,
        form: VppIncentivesSelection,
      } as IPart,
    ],
  },
  [`contract-signing`]: {
    id: `contract-signing`,
    title: `contractSigning`,
    parts: [
      {
        id: `contract-status`,
        title: `contractStatus`,
        summary: `contractStatusDesc`,
        form: ContractStatus,
      },
    ],
  },
  share: {
    id: `share`,
    title: `share`,
    parts: [{ id: `presentation`, title: `share`, form: SharePresentation }],
  },
}

export const setupSteps = Object.values(setupStepsIndex).filter(
  (step) => step.id !== `equipment-selection`,
)
